import z from "zod";
import { UserSchema } from "./account";

export type InvoiceType = z.infer<typeof InvoiceSchema>;
export type PaymentMethodType = z.infer<typeof PaymentMethodSchema>;
export type PaymentType = z.infer<typeof PaymentSchema>;
export type CreditCardType = z.infer<typeof CreditCardSchema>;
export type BillingPlanIdentifierType = z.infer<typeof BillingPlanIdentifierSchema>;
export type CurrentSubscribingPlanType = z.infer<typeof CurrentSubscribingPlanSchema>;

export const CreditCardSchema = z.object({
  owner_name: z.string(),
  brand: z.string(),
  last4: z.string(),
  exp_month: z.number(),
  exp_year: z.number(),
  country: z.string()
});

export const PaymentMethodSchema = z.object({
  type: z.string(),
  is_default: z.boolean(),
  credit_card: CreditCardSchema.optional().nullable()
});

export const PaymentSchema = z.object({
  id: z.number(),
  user: UserSchema,
  merchant_payment_id: z.string(),
  amount: z.number(),
  currency: z.string(),
  qr_code: z.string(),
  expiry_date: z.number(),
  accepted_at: z.number(),
  created_at: z.string()
});

export const InvoiceSchema = z.object({
  amount_due: z.number(),
  payment_method: PaymentMethodSchema.nullable(),
  paid_at: z.number(),
  status: z.string()
});

export const BillingPlanIdentifierSchema = z.enum(["monthly_plan", "annual_plan", "eternal_plan"]);

export type BillingPlanLabel = {
  name: string;
  description?: string;
  price: string;
  per: string;
  available: string[];
  popupContent?: string | undefined;
};

export const billingPlanLabelMap: Readonly<
  Record<BillingPlanIdentifierType | "free", BillingPlanLabel>
> = {
  free: {
    name: "フリープラン",
    price: "￥0",
    per: "",
    available: ["毎月100クレジット付与"]
  },
  monthly_plan: {
    name: "プレミアム月額プラン",
    price: "￥1,380",
    per: "/月",
    available: ["クレジット無制限"]
  },
  annual_plan: {
    name: "プレミアム年額プラン",
    description: "￥8,280円 毎年請求",
    price: "￥690",
    per: "/月",
    available: ["クレジット無制限"],
    popupContent: "年間￥8,280お得！"
  },
  eternal_plan: {
    name: "プレミアム永年プラン",
    price: "￥16,560",
    per: "",
    available: ["無期限で利用可能"]
  }
};

export const CurrentSubscribingPlanSchema = z.object({
  id: z.number().int(),
  enrollment_date: z.string().datetime({ offset: true }),
  next_invoice_date: z.string().datetime({ offset: true }).nullable(),
  cancellation_date: z.string().datetime({ offset: true }).nullable(),
  cancellation_reason: z.string().nullable(),
  billing_plan_identifier: BillingPlanIdentifierSchema,
  billing_plan_name: z.string(),
  billing_plan_price: z.number().int(),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
  payment_method: PaymentMethodSchema.nullable()
});
